export default function HeroSection() {
  return (
    <div className="hidden lg:flex w-[52%] relative items-center justify-center overflow-hidden">
      <div className="absolute inset-0 z-0 bg-slate-900">
        <img 
          src="https://images.unsplash.com/photo-1620712943543-bcc4688e7485?q=80&w=1600&auto=format&fit=crop" 
          alt="AI Concept Background" 
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-br from-[#1d57a5]/90 via-[#1d57a5]/80 to-[#36a852]/90 mix-blend-multiply" />
      </div>

      <div className="relative z-10 p-12 flex flex-col justify-end h-full w-full max-w-3xl text-white">
        <h1 className="text-3xl xl:text-[2.1rem] font-bold mb-4 leading-tight">
          Unlock the power of your <br/> enterprise data.
        </h1>
        <p className="text-base text-white/80 max-w-xl leading-relaxed">
          Connect your databases, index your documents, and get immediate, intelligent answers. The secure, resilient AI workspace tailored for modern teams.
        </p>
      </div>
    </div>
  );
}
